import { type RowCellMenuListItemProps } from '@webapp/components/DataTable'
import { type CreditCardItem } from '@webapp/modules/accounts-payable/entities/CreditCardItem'
import { useCreditCardItemListPresenter } from './useCreditCardItemListPresenter'
import { CreditCardItemTable } from '../../views/CreditCardItemTable'

export interface ICreditCardItemListPresenterProps {
  accountId: number
  /** Tab state is FS-owned (Tab Navigation Rule) */
  archived: boolean
  /** Move-mode selection bridge to move-credit-card-items (ADR-9) */
  selectionMode: boolean
  selectedItemIds: number[]
  onSelectionChange: (ids: number[]) => void
  /** FS slot composing Edit/Archive/Unarchive from sibling features */
  renderRowMenu: (item: CreditCardItem) => RowCellMenuListItemProps[]
}

export const CreditCardItemListPresenter = ({
  accountId,
  archived,
  selectionMode,
  selectedItemIds,
  onSelectionChange,
  renderRowMenu,
}: ICreditCardItemListPresenterProps) => {
  const {
    data: { items },
    states: { isLoading },
  } = useCreditCardItemListPresenter({ accountId, archived })

  return (
    <CreditCardItemTable
      items={items}
      isLoading={isLoading}
      selectionMode={selectionMode}
      selectedItemIds={selectedItemIds}
      onSelectionChange={onSelectionChange}
      renderRowMenu={renderRowMenu}
    />
  )
}

CreditCardItemListPresenter.displayName = 'CreditCardItemListPresenter'
